const NonconformanceHoldTags = () => import("Modules/manufacturing/nonconformance_hold_tags/views/NonconformanceHoldTags");
const NonconformanceHoldTagsForm = () => import("Modules/manufacturing/nonconformance_hold_tags/views/NonconformanceHoldTagsForm");

export default {
    children: [
        {
            path: "nonconformance_hold_tags",
            name: "nonconformance_hold_tags",
            component: NonconformanceHoldTags,
            meta: {
                requiresAuth: true,
                title: "lang.nonconformance_hold_tags",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["nonconformance_hold_tags.read"],
            },
        },
        {
            path: "nonconformance_hold_tag/:id?",
            name: "nonconformance_hold_tag",
            component: NonconformanceHoldTagsForm,
            meta: {
                requiresAuth: true,
                title: "lang.nonconformance_hold_tags",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["nonconformance_hold_tags.read"],
            },
        },
    ],
};
